export { default as invoiceInput } from './invoiceInput'; // 发票组 接口
export { default as invoiceImport } from './invoiceImport'; //
export { default as inputSettlement } from './inputSettlement'; //进项结算单
export { default as system } from './systemManage/system'; //  公司管理接口
export { default as department } from './systemManage/department'; //  公司管理接口,部门
export { default as invoiceInformation } from './invoiceInformation'; // 发票及发票组附加信息 接口
export { default as authManage } from './authManage'; //勾选认证 api 接口
export { default as outputApi } from './outputSettlement';
export { default as createCompany } from './createCompany'; //  创建公司接口
export { default as companyInfo } from './systemManage/companyInfo'; // 公司信息接口
export { default as appInstance } from './appInstance'; // app应用 接口
export { default as appInfo } from './appInfo'; // app应用 接口
export { default as network } from './network'; // 网络
export { default as invoiceManage } from './invoiceManage';//进项发票管理
export { default as invoiceCompare } from './invoiceCompare';//进项发票管理
export { default as login } from './login';//登录辅助功能相关接口
export { default as userCenter } from './userCenter';//用户中心相关接口
export { default as orgInfo } from './orgInfo';//用户中心相关接口
export { default as qualification } from './systemManage/qualification';
export { default as document } from './document';// 单据文档
export { default as passwordRule } from './passwordRule'; //密码规则
export { default as guide } from './guide'; // 新手引导
export { default as gettingStarted } from './gettingStarted'; // 引导页
export { default as invite } from './invite'; // 公共邀请
export { default as tagmodule } from './tagmodule'; // 标签模块
export { default as agentQuery } from './agentQuery'; // 代理商模块
export { default as remindCheck } from './remindCheck'; 
export { default as collection } from './collection'; 



// WEBPACK FOOTER //
// ./src/api/index.ts